// extracted by mini-css-extract-plugin
module.exports = {"container":"DragList_container__2UXUT","content":"DragList_content__3Sf7B"};